import {environment} from "../../../environments/environment";
import {FuncionesExterno} from "../../externo/funciones-Externo";
import {catchError} from "rxjs/operators";
import {of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Component} from "@angular/core";
import {PeticionesComponent} from "../peticiones.component";
import {PetTall} from "../../../Models/PetTall";
export class Peticiones {

  public static getPeticiones(http: HttpClient, parametros: any) {

    // Se añade bearer token al header
    const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };

    return new Promise<any>((resolve, reject) =>
    {
      http.post<any[]>(environment.articulosWSBase + "/PetTall/getPetTallAccessToken", parametros,  { headers } )
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          },
        })
    });

  }

  public static getDetallePet(http: HttpClient, parametros: any) {

    // Se añade bearer token al header
    const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };

    return new Promise<any>((resolve, reject) =>
    {
      http.post<any[]>(environment.articulosWSBase + "/PetTall/getDetallePetAccessToken", parametros,  { headers } )
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          },
        })
    });

  }

  public static getDetalleDevolucionPet(http: HttpClient, parametros: string) {

    // Se añade bearer token al header
    const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };

    return new Promise<any>((resolve, reject) =>
    {
      http.post<any[]>(environment.articulosWSBase + "/PetTall/GetDetalleDevolucionExterno", parametros,  { headers } )
          .subscribe
          ({
            next(res)
            {
              resolve(res);
            },
            error(err)
            {
              console.error(err);
              reject(err);
            },
          })
    });

  }

}
